import {
  Typography,
  StyledDiv,
  Button,
  Spacing,
  Checkbox,
  SearchField,
  StyledFixedButtonWrapper,
  Card,
} from '@taleemabad/dsm/components';
import styled from '@emotion/styled';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

export interface School {
  id: string;
  emis: string;
  name: string;
  checked: boolean;
}

export interface RmEditSchoolsProps {
  coachName: string;
  region: string;
  schools: School[];
  searchValue: string;
  onSearchChange: (value: string) => void;
  onToggleSchool: (id: string) => void;
  onSave: () => void;
}

export const RmEditSchools = ({
  coachName,
  region,
  schools,
  searchValue,
  onSearchChange,
  onToggleSchool,
  onSave,
}: RmEditSchoolsProps) => (
  <StyledDiv
    flexDirection="column"
    width="100%"
    padding="0 0 var(--rk-spacing-xxxxxxxxxxl) 0"
  >
    <Typography variant="textBodyLarge">Coach</Typography>
    <Typography variant="textHeadlineMediumLightOnSurface">
      {coachName}
    </Typography>
    <Spacing marginBottom="xl" />
    <StyledDiv alignItem="center" gap={4}>
      <Typography variant="textTitleMedium">Region:</Typography>
      <Typography variant="textBodyMediumOnSurfaceVariant">{region}</Typography>
    </StyledDiv>
    <Spacing marginBottom="sm" />
    <Typography variant="textBodyLargeOnSurfaceVariant">
      Select schools to assign to the coach
    </Typography>
    <Spacing marginBottom="xl" />

    <StyledSearchFieldWrapper>
      <SearchField
        variant="outlined"
        value={searchValue}
        onChange={onSearchChange}
        label="Schools"
      />
    </StyledSearchFieldWrapper>
    <Spacing marginBottom="lg" />
    <StyledCardsContainer>
      {schools.length === 0 ? (
        <>
          <Spacing marginTop="xxxxl" />
          <Typography
            variant="textBodyMedium"
            textAlign="center"
            color="var(--md-sys-color-on-surface-variant)"
          >
            No schools available.
          </Typography>
        </>
      ) : (
        schools.map((school, idx) => (
          <>
            <Card
              width="100%"
              variant="outline"
              minHeight="60px"
              key={school.id}
            >
              <StyledDiv>
                <Checkbox
                  checked={school.checked}
                  onChange={() => onToggleSchool(school.id)}
                />
                <StyledDiv flexDirection="column">
                  <Typography variant="textBodyMedium">
                    EMIS: {school.emis}
                  </Typography>
                  <StyledTextWrapper>
                    <Typography variant="textBodyMedium">
                      {school.name}
                    </Typography>
                    <StyledTextWrapper />
                  </StyledTextWrapper>
                </StyledDiv>
              </StyledDiv>
            </Card>

            <StyledFixedButtonWrapper>
              <Button onClick={onSave}>Save Schools</Button>
            </StyledFixedButtonWrapper>
          </>
        ))
      )}
    </StyledCardsContainer>
  </StyledDiv>
);

const StyledTextWrapper = styled.div`
  width: 100%;
  word-break: break-word;
  white-space: normal;
  overflow-wrap: anywhere;
`;

const StyledCardsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--rk-spacing-md);

  ${mq(BreakpointSizes.desktop)} {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }
`;

const StyledSearchFieldWrapper = styled.div`
  width: 100%;
  ${mq(BreakpointSizes.desktop)} {
    width: 50%;
  }
`;
